import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Constantes } from '../../../compartido/constantes/constantes';
import { Router } from '@angular/router';
import { LoadingPage } from '../../../compartido/cargando/loading';
import { ConfirmationService } from 'primeng/api';
import { RequerimientoCatering, DisponibilidadDTO } from 'npm-modelado-catering';
import { RequerimientoCateringService, EstadoRequerimientoCateringService, DisponibilidadService, ConfiguracionGeneralService } from 'npm-servicios-catering';
import { RequerimientoCateringDTO, EstadoRequerimientoCatering } from 'npm-modelado-catering';
import { DatosSesionService } from '../../servicios/datos-sesion.service';
import { DatePipe } from '@angular/common';
import { Table } from 'primeng/table';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import * as moment from 'moment';


@Component({
  selector: 'app-requerimiento-listar-calendario',
  templateUrl: './requerimiento-listar-calendario.component.html',
  styleUrls: ['./requerimiento-listar-calendario.component.css']
})
export class RequerimientoListarCalendarioComponent extends LoadingPage implements OnInit {


  lstEstadoRequerimiento: EstadoRequerimientoCatering[];
  lstRequerimientoCateringDTO: RequerimientoCateringDTO[];
  requerimientoCateringSeleccionado: RequerimientoCateringDTO;
  requerimientoCateringSeleccionadoCalendario: RequerimientoCateringDTO = {};
  nombrePlanificacion: string;
  requerimientoGuardar: RequerimientoCatering = {};
  fechaInicio: Date;
  idEstadoElaborada: number = 0;
  idEstadoPorRevisar: number = 0;
  idEstadoConfirmar: number = 0;
  idEstadoCancelar: number = 0;
  buscarEv: string;
  display: boolean = false;
  @ViewChild('dt') table: Table;
  optionsEstadoRequerimientos: any[];
  optionsTiposVistaPlanificacion: any[];
  mesPlanificacion: string;
  lstDisponibilidades: DisponibilidadDTO[];
  numeroMesPlanificacion: number;
  ingresaComoPlanificacion: boolean = false;
  ingresaComoExcepcional: boolean = false;
  displayInfo: boolean = false;
  selectedTipoVista: string;
  showListado: boolean = true;
  options: any;
  titleDialogEvent: String = "";
  header: any;
  actividadesEvents: any[] = [];
  fechaCalendario: Date;
  colorServicioPush: string = "";
  isCheckedElaborada: boolean = true;
  isCheckedPorAprobar: boolean = true;
  isCheckedAprobada: boolean = true;
  isCheckedNoAprobada: boolean = true;
  isCheckedAceptada: boolean = true;
  isCheckedRechazada: boolean = true;
  isCheckedConfirmada: boolean = true;
  isCheckedNoConfirmada: boolean = true;
  isCheckedCancelada: boolean = true;
  disabledCampos: boolean = false;
  nombreActividadCalendarioElectoral: String = "";
  longDate: boolean = false;
  dateRangeDialogEvent: String = "";
  fechaInicioDialog: Date;
  fechaFinDialog: Date;
  muestra: boolean = false;
  direccionTooltip: string = "";
  nombreTooltip: string = "";
  direccionReferenciaEventoTooltip: string = "";
  observacionesEventoTooltip: string = "";
  requerimientoCateringSeleccionadoCalendarioList: RequerimientoCateringDTO[];
  hayDireccionReferencia: boolean = false;
  hayNombrePersonaRecibir: boolean = false;
  hayHoraServicioEnEvento: boolean = false;
  hayCelularPersonaRecibir: boolean = false;
  hayObservaciones: boolean = false;
  estadosServiciosParaMostrar: string[]
  position: string;
  auxHoraServicioEnEvento: string = "";
  fechaHoraInicioExcep: Date = new Date();
  fechaHoraFinExcep: Date = new Date();
  busy: Subscription;
  disponibilidadExcepcional: DisponibilidadDTO = {};

  fechaAuxEvento = new Date();
  fechaAuxActual = new Date();

  selectedTipoEstado: string;
  numeroHorasConfirmar: number = 0;
  numeroHorasCancelar: number = 0;
  requerimientoCateringRecuperado: RequerimientoCatering;
  constructor(private router: Router, private disponibilidadService: DisponibilidadService,
    private confirmationService: ConfirmationService, private requerimientoCateringService: RequerimientoCateringService,
    private datosSesionService: DatosSesionService, public datepipe: DatePipe,
    private estadoRequerimientoCateringService: EstadoRequerimientoCateringService,
    private configuracionGeneralCateringSerivice: ConfiguracionGeneralService,
    private datePipe: DatePipe
  ) {
    super(false);
  }

  verificaSiEsPlanificacion() {
    this.lstDisponibilidades.forEach(disponibilidad => {
      if (disponibilidad.tipoDisponibilidad.localeCompare("NORMAL") == 0) {

        if ((new Date(disponibilidad.fechaInicio + "T00:00:00").getMonth()) == (this.numeroMesPlanificacion - 1)) {
          this.datosSesionService.idDisponibilidadPlanificacion = disponibilidad.idDisponibilidad;
          this.datosSesionService.guardarIdDisponibilidadPlanificacion(disponibilidad.idDisponibilidad);
          this.ingresaComoPlanificacion = true;
          return;
        }
      }
    });
  }

  verificaSiEsExcepcional() {
    this.lstDisponibilidades.forEach(disponibilidad => {
      if (disponibilidad.tipoDisponibilidad.localeCompare("EXCEPCIONAL") == 0) {
        if ((new Date(disponibilidad.fechaInicio + "T00:00:00").getMonth()) == (this.numeroMesPlanificacion)) {
          this.datosSesionService.idDisponibilidadPlanificacion = disponibilidad.idDisponibilidad;
          this.datosSesionService.guardarIdDisponibilidadPlanificacion(disponibilidad.idDisponibilidad);
          this.disponibilidadExcepcional = disponibilidad;//asignamos la disponibilidad excepcional para poder utilizar luego 
          this.ingresaComoExcepcional = true;
          return;
        }
      }
    });
  }

  /*async agregarClick() {

    this.verificaSiEsPlanificacion();
    if (this.ingresaComoPlanificacion) {

      this.router.navigate(['/planificacion/requerimiento-crear']);
      this.datosSesionService.numeroMesPlanificacion = this.numeroMesPlanificacion;
      this.datosSesionService.guardarNumeroMesPlanificacion(this.numeroMesPlanificacion);
    } else {
      this.verificaSiEsExcepcional();
      if (this.ingresaComoExcepcional) {

        this.router.navigate(['/planificacion/requerimiento-crear']);
        this.datosSesionService.numeroMesPlanificacion = this.numeroMesPlanificacion;
        this.datosSesionService.guardarNumeroMesPlanificacion(this.numeroMesPlanificacion);
      } else {

        this.mostrarMensajeInfo("No se permite agregar requerimientos, no hay una disponibilidad activa, consulte al administrador del sistema");
      }
    }

  }*/

  ngOnInit() {
    this.ingresaComoExcepcional = false;
    this.ingresaComoPlanificacion = false;

    this.estadosServiciosParaMostrar = [];
    this.optionsEstadoRequerimientos = Constantes.ESTADO_REQUERIMIENTOS_CONFIRMAR_CANCELAR;
    this.optionsTiposVistaPlanificacion = Constantes.ESTADO_TIPOS_VISTAS_PLANIFICACIONES;

    this.cargarEnviroment();
    this.obtenerRequerimientoCatering();
    this.nombrePlanificacion = this.datosSesionService.nombrePlanificacionActual;
    this.ubicaNumeroMes();

    this.obtenerEstadoRequerimiento();
    this.obtenerDisponibilidadesActivas();


  }

  cargarEnviroment() {
    this.requerimientoCateringService.set_constantes(Constantes);
    this.estadoRequerimientoCateringService.set_constantes(Constantes);
    this.disponibilidadService.set_constantes(Constantes);
    this.configuracionGeneralCateringSerivice.set_constantes(Constantes);
  }
  ubicaNumeroMes() {
    this.mesPlanificacion = this.datosSesionService.nombrePlanificacionActual;

    if (this.mesPlanificacion.localeCompare("ENERO") == 0) {
      this.numeroMesPlanificacion = 0;
    } else {
      if (this.mesPlanificacion.localeCompare("FEBRERO") == 0) {
        this.numeroMesPlanificacion = 1;
      } else {
        if (this.mesPlanificacion.localeCompare("MARZO") == 0) {
          this.numeroMesPlanificacion = 2;
        } else {
          if (this.mesPlanificacion.localeCompare("ABRIL") == 0) {
            this.numeroMesPlanificacion = 3;
          } else {
            if (this.mesPlanificacion.localeCompare("MAYO") == 0) {
              this.numeroMesPlanificacion = 4;
            } else {
              if (this.mesPlanificacion.localeCompare("JUNIO") == 0) {
                this.numeroMesPlanificacion = 5;
              } else {
                if (this.mesPlanificacion.localeCompare("JULIO") == 0) {
                  this.numeroMesPlanificacion = 6;
                } else {
                  if (this.mesPlanificacion.localeCompare("AGOSTO") == 0) {
                    this.numeroMesPlanificacion = 7;
                  } else {
                    if (this.mesPlanificacion.localeCompare("SEPTIEMBRE") == 0) {
                      this.numeroMesPlanificacion = 8;
                    } else {
                      if (this.mesPlanificacion.localeCompare("OCTUBRE") == 0) {
                        this.numeroMesPlanificacion = 9;
                      } else {
                        if (this.mesPlanificacion.localeCompare("NOVIEMBRE") == 0) {
                          this.numeroMesPlanificacion = 10;
                        } else {
                          if (this.mesPlanificacion.localeCompare("DICIEMBRE") == 0) {
                            this.numeroMesPlanificacion = 11;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }

        }
      }
    }
  }

  obtenerDisponibilidadesActivas() {
    this.busy = this.disponibilidadService.obtenerIdDisponibilidadActivaParaPlanificacion(this.datosSesionService.unidadSeleccionadaAplicativo.idUnidad).then(req => {
      if (req) {
        this.lstDisponibilidades = req;
      }
    }).catch(error => {
      this.mostrarMensajeError("No se encuentra disponible el servicio de obtener disponibilidades activas");
    });
  }

  obtenerRequerimientoCatering() {
    this.busy = this.requerimientoCateringService.listarRequerimientoCateringByIdPlanificacion(this.datosSesionService.idPlanificacionActual).then(req => {
      if (req) {
        this.lstRequerimientoCateringDTO = req;
        for (var i = 0; i < this.lstRequerimientoCateringDTO.length; i++) {
          this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento = this.lstRequerimientoCateringDTO[i].valorUnitarioSubCategoria * this.lstRequerimientoCateringDTO[i].cantidad;
          this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento = Math.round(this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento * 10) / 10;
        }
        this.selectedTipoVista = 'CALENDARIO';
        this.showListado = false;
        this.cambiaTipoVista();

      }
    }).catch(error => {
      this.mostrarMensajeError("No se encuentra disponible el servicio de listar servicios, intente más adelante refrescando la pestaña o comuníquese con el administrador");
    });
  }



  /*eliminarClick() {
    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idRequerimientoCatering) {
      if (this.requerimientoCateringSeleccionado.idEstadoRequerimiento == this.idEstadoElaborada) {
        this.confirmationService.confirm({
          key: 'autorizacion',
          header: this._eliminarServicioCatering,
          message: '¿Está seguro que desea eliminar el servicio seleccionado?',
          accept: () => {
            this.eliminarRequerimientoCatering();
          }
        });
      } else {
        this.mostrarMensajeError("Sólo se permite eliminar un servicio en estado elaborada");
      }
    } else {
      this.mostrarMensajeInfo(this._noObjetoGrillaEliminar);
    }
  }*/

  /*copiarClick() {
    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idRequerimientoCatering) {
      this.confirmationService.confirm({
        key: 'autorizacion',
        header: this._copiarServicioCatering,
        message: '¿Desea crear una copia en estado elaborada del registro seleccionado (Datos del evento y detalles del producto seleccionado)?',
        accept: () => {
          this.copiarRequerimientoCatering();
        }
      });
    } else {
      this.mostrarMensajeInfo(this._noObjetoGrillaCopiar);

    }
  }*/

  /*async copiarRequerimientoCatering() {
    this.cargaDatosRequerimientoGuardar(this.requerimientoCateringSeleccionado.idEstadoRequerimiento, "S");
    this.requerimientoGuardar.nombreEvento = "Copia de " + this.requerimientoCateringSeleccionado.nombreEvento;
    this.actualizarRequerimientoCatering();
  }*/

  actualizarRequerimientoCatering() {//crea la copia del registro    
    this.requerimientoGuardar.idRequerimientoCatering = null;
    this.requerimientoGuardar.nombreEvento = this.requerimientoGuardar.nombreEvento;
    this.requerimientoGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering = this.idEstadoElaborada;
    this.requerimientoGuardar.estaActivo = "S";

    if (this.requerimientoGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering != 0) {
      this.busy = this.requerimientoCateringService.actualizar(this.requerimientoGuardar, this.requerimientoGuardar.horaInicioEvento.toString(), this.requerimientoGuardar.horaFinEvento.toString(), this.auxHoraServicioEnEvento).then(req => {
        if (req) {
          this.obtenerRequerimientoCatering();
        }
      }).catch(error => {
        this.mostrarMensajeError(error);
      });
    } else {
      this.mostrarMensajeError("No se puede copiar el registro, no existe el tipo de requerimiento elaborada, comuníquese con el administrador");
    }
  }

  obtenerEstadoRequerimiento() {
    this.busy = this.estadoRequerimientoCateringService.listarEstadoRequerimientoCatering().then(estadoRequerimiento => {
      if (estadoRequerimiento) {
        this.lstEstadoRequerimiento = estadoRequerimiento;
        for (var i = 0; i < this.lstEstadoRequerimiento.length; i++) {
          if (this.lstEstadoRequerimiento[i].nombre.localeCompare("ELABORADA") == 0) {
            this.idEstadoElaborada = this.lstEstadoRequerimiento[i].idEstadoRequerimientoCatering;
          }
          if (this.lstEstadoRequerimiento[i].nombre.localeCompare("POR APROBAR") == 0) {
            this.idEstadoPorRevisar = this.lstEstadoRequerimiento[i].idEstadoRequerimientoCatering;
          }

          if (this.lstEstadoRequerimiento[i].nombre.localeCompare(Constantes.ESTADO_CONFIRMAR) == 0)
            this.idEstadoConfirmar = this.lstEstadoRequerimiento[i].idEstadoRequerimientoCatering;

          if (this.lstEstadoRequerimiento[i].nombre.localeCompare(Constantes.ESTADO_CANCELAR) == 0)
            this.idEstadoCancelar = this.lstEstadoRequerimiento[i].idEstadoRequerimientoCatering;

        }
      }
    }).catch(error => {
      this.mostrarMensajeError("No se encuentra disponible el servicio de listar estado requerimiento, intente más adelante refrescando la pestaña o comuníquese con el administrador");
    });
  }

  cargaDatosRequerimientoGuardar(idEstadoReqCatering, estaActivo) {//util para el calendario c

    this.requerimientoGuardar = new RequerimientoCatering();
    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.nombreEvento.includes("...")) {
      this.requerimientoGuardar.nombreEvento = this.nombreTooltip;
    } else {
      this.requerimientoGuardar.nombreEvento = this.requerimientoCateringSeleccionado.nombreEvento;
    }

    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.direccionEvento.includes("...")) {
      this.requerimientoGuardar.direccionEvento = this.direccionTooltip;
    } else {
      this.requerimientoGuardar.direccionEvento = this.requerimientoCateringSeleccionado.direccionEvento;
    }


    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.direccionReferenciaEvento != null && this.requerimientoCateringSeleccionado.direccionReferenciaEvento.includes("...")) {
      this.requerimientoGuardar.direccionReferenciaEvento = this.direccionReferenciaEventoTooltip;
    } else {
      this.requerimientoGuardar.direccionReferenciaEvento = this.requerimientoCateringSeleccionado.direccionReferenciaEvento;
    }

    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.observaciones != null && this.requerimientoCateringSeleccionado.observaciones.includes("...")) {
      this.requerimientoGuardar.observaciones = this.observacionesEventoTooltip;
    } else {
      this.requerimientoGuardar.observaciones = this.requerimientoCateringSeleccionado.observaciones;
    }

    console.log("Hora servicio en evento " + this.requerimientoCateringSeleccionado.horaServicioEnEvento);
    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.horaServicioEnEvento != null) {
      this.requerimientoGuardar.horaServicioEnEvento = this.requerimientoCateringSeleccionado.horaServicioEnEvento;
      this.auxHoraServicioEnEvento = this.requerimientoCateringSeleccionado.horaServicioEnEvento.toString();
    } else {
      this.auxHoraServicioEnEvento = "";
    }

    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idPersonaResponsableRecibirServicio != null) {
      this.requerimientoGuardar.responsableRecibirServicio = parseInt(this.requerimientoCateringSeleccionado.idPersonaResponsableRecibirServicio);
    }

    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.telefonoResponsable != null) {
      this.requerimientoGuardar.telefonoResponsable = this.requerimientoCateringSeleccionado.telefonoResponsable;

    }

    this.requerimientoGuardar.idRequerimientoCatering = this.requerimientoCateringSeleccionado.idRequerimientoCatering;
    this.requerimientoGuardar.estaActivo = estaActivo;
    this.requerimientoGuardar.cantidad = this.requerimientoCateringSeleccionado.cantidad;
    this.requerimientoGuardar.direccionEvento = this.requerimientoCateringSeleccionado.direccionEvento;
    this.requerimientoGuardar.estadoRequerimientoCatering = {};
    this.requerimientoGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering = idEstadoReqCatering;
    this.requerimientoGuardar.fechaEvento = this.requerimientoCateringSeleccionado.fechaEvento;
    this.requerimientoGuardar.horaFinEvento = this.requerimientoCateringSeleccionado.horaFinEvento;
    this.requerimientoGuardar.horaInicioEvento = this.requerimientoCateringSeleccionado.horaInicioEvento;

    this.requerimientoGuardar.idUsuarioCreacion = this.requerimientoCateringSeleccionado.idUsuarioCreacion;
    this.requerimientoGuardar.planificacionCatering = {};
    this.requerimientoGuardar.planificacionCatering.idPlanificacionCatering = this.datosSesionService.idPlanificacionActual;
    this.requerimientoGuardar.subCategoria = {};
    this.requerimientoGuardar.subCategoria.idSubCategoria = this.requerimientoCateringSeleccionado.idSubCategoria;
    this.requerimientoGuardar.usuarioCreacion = this.requerimientoCateringSeleccionado.usuarioCreacion;
    this.requerimientoGuardar.fechaCreacion = this.requerimientoCateringSeleccionado.fechaCreacion;
    this.requerimientoGuardar.disponibilidadPlanificacion = {};
    this.requerimientoGuardar.disponibilidadPlanificacion.idDisponibilidadPlanificacion = this.requerimientoCateringSeleccionado.idDisponibilidadPlanificacion;
    this.requerimientoGuardar.idUsuarioCreacion = this.requerimientoCateringSeleccionado.idUsuarioCreacion;
    this.requerimientoGuardar.editadoAceptado = this.requerimientoCateringSeleccionado.editadoAceptado;
  }

  async eliminarRequerimientoCatering() {

    this.cargaDatosRequerimientoGuardar(this.requerimientoCateringSeleccionado.idEstadoRequerimiento, "N");

    this.requerimientoCateringService.actualizar(this.requerimientoGuardar, this.requerimientoCateringSeleccionado.horaInicioEvento.toString(), this.requerimientoCateringSeleccionado.horaFinEvento.toString(), this.auxHoraServicioEnEvento).then(req => {
      if (req) {
        this.obtenerRequerimientoCatering();
        this.nombrePlanificacion = this.datosSesionService.nombrePlanificacionActual;
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }

  /*regresarClick() {
    this.router.navigate(['/planificacion/planificacion-listar/']);
  }*/

  editarClick() {

    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idRequerimientoCatering) {
      this.datosSesionService.idDisponibilidadPlanificacion = this.requerimientoCateringSeleccionado.idDisponibilidadPlanificacion;
      this.datosSesionService.guardarIdDisponibilidadPlanificacion(this.requerimientoCateringSeleccionado.idDisponibilidadPlanificacion);
      if (this.requerimientoCateringSeleccionado.nombreEstadoRequerimiento == Constantes.ESTADO_ELABORADA) {
        this.datosSesionService.numeroMesPlanificacion = this.numeroMesPlanificacion;
        this.datosSesionService.guardarNumeroMesPlanificacion(this.numeroMesPlanificacion);
        this.router.navigate(['/planificacion/requerimiento-crear/'],
          { queryParams: { id: this.requerimientoCateringSeleccionado.idRequerimientoCatering, estado: this.disabledCampos } });

      } else if (this.requerimientoCateringSeleccionado.nombreEstadoRequerimiento == Constantes.ESTADO_ACEPTADA) {

        this.disabledCampos = true;
        this.datosSesionService.numeroMesPlanificacion = this.numeroMesPlanificacion;
        this.datosSesionService.guardarNumeroMesPlanificacion(this.numeroMesPlanificacion);
        this.router.navigate(['/planificacion/requerimiento-crear/'],
          { queryParams: { id: this.requerimientoCateringSeleccionado.idRequerimientoCatering, estado: this.disabledCampos } }
        );

      } else {
        this.mostrarMensajeError("Sólo se permite editar un servicio en estado elaborada ó aceptada");

      }
    } else {
      this.mostrarMensajeInfo(this._noObjetoGrillaEditar);
    }
  }

  verificarEstadoRequerimiento() {
    if (this.requerimientoCateringSeleccionado) {
      if (this.requerimientoCateringSeleccionado.nombreEstadoRequerimiento == Constantes.ESTADO_ELABORADA ||
        this.requerimientoCateringSeleccionado.nombreEstadoRequerimiento == Constantes.ESTADO_ACEPTADA) {
        if (this.requerimientoCateringSeleccionado.nombreEstadoRequerimiento == Constantes.ESTADO_ACEPTADA) {
          this.disabledCampos = true;
        }
      }
    }
  }

  onFechaEventoChange(value) {
    if (this.buscarEv.length == 10) {
      var dia = this.buscarEv.substring(0, this.buscarEv.indexOf('-'));
      var mes = this.buscarEv.substring(this.buscarEv.indexOf('-') + 1, this.buscarEv.indexOf('-') + 3);
      var año = this.buscarEv.substring(this.buscarEv.lastIndexOf('-') + 1);

      this.table.filter(año + "-" + mes + "-" + dia, 'fechaEvento', 'equals');
    } else {
      this.table.filter(this.buscarEv, 'fechaEvento', 'equals');
    }
  }

  /*confirmarCancelarClick() {
    this._obtenerTiempoConfirmarServicioCatering();
    this._obtenerTiempoCancelarServicioCatering();
    if (this.requerimientoCateringSeleccionado.nombreEstadoRequerimiento == Constantes.ESTADO_ACEPTADA) {

      if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idRequerimientoCatering) {
        this.obtenerRequerimientoPorId(this.requerimientoCateringSeleccionado.idRequerimientoCatering);
        this.display = true;
      } else {
        this.mostrarMensajeInfo(this._noObjetoGrillaContinuar);
      }
    } else {
      this.mostrarMensajeInfo(this._mendajeValidacionEstadoBotonConfirmarCancelar);
    }
  }*/

  cancelar() {
    this.display = false;
    this.selectedTipoEstado = null;
  }

  /*enviarAprobacionClick() {
    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idRequerimientoCatering) {
      if (this.requerimientoCateringSeleccionado.idEstadoRequerimiento == this.idEstadoElaborada) {
        this.confirmationService.confirm({
          key: 'autorizacion',
          header: this._tituloEnviarRequerimientoCateringAprobacion,
          message: '¿Está seguro que desea enviar este registro para aprobación?',
          accept: async () => {
            this.cargaDatosRequerimientoGuardar(this.idEstadoPorRevisar, "S");
            this.busy = this.requerimientoCateringService.actualizar(this.requerimientoGuardar, this.requerimientoCateringSeleccionado.horaInicioEvento.toString(), this.requerimientoCateringSeleccionado.horaFinEvento.toString(), this.auxHoraServicioEnEvento).then(req => {
              if (req) {
                this.obtenerRequerimientoCatering();
                this.nombrePlanificacion = this.datosSesionService.nombrePlanificacionActual;
              }
            }).catch(error => {
              this.mostrarMensajeError(error);
            });
          }
        });
      } else {
        this.mostrarMensajeError("Debe seleccionar un servicio en estado elaborada");
      }
    } else {
      this.mostrarMensajeInfo(this._noObjetoGrillaEnviarParaAprobar);
    }
  }*/
  infoClick() {
    this.displayInfo = true;
  }
  infoCerrarClick() {
    this.displayInfo = false;
  }

  cargaColor(nombreEstado) {

    if (nombreEstado.localeCompare("ELABORADA") == 0) {
      this.colorServicioPush = Constantes.COLOR_ESTADO_ELABORADA;
    } else {
      if (nombreEstado.localeCompare("POR APROBAR") == 0) {
        this.colorServicioPush = Constantes.COLOR_ESTADO_PORAPROBAR;

      } else {
        if (nombreEstado.localeCompare("APROBADA") == 0) {
          this.colorServicioPush = Constantes.COLOR_ESTADO_APROBADA;

        } else {

        }
      }
    }
  }

  cargarInformacionCalendario() {

    this.actividadesEvents = [];

    this.lstRequerimientoCateringDTO.forEach(async element => {

      let start = element.fechaEvento.toString() + "T" + element.horaInicioEvento.toString() + "Z";
      let end = element.fechaEvento.toString() + "T" + element.horaFinEvento.toString() + "Z";

      if (element.nombreEstadoRequerimiento.localeCompare("ELABORADA") == 0) {
        this.colorServicioPush = Constantes.COLOR_ESTADO_ELABORADA;

      } else {
        if (element.nombreEstadoRequerimiento.localeCompare("POR APROBAR") == 0) {
          this.colorServicioPush = Constantes.COLOR_ESTADO_PORAPROBAR;

        } else {
          if (element.nombreEstadoRequerimiento.localeCompare("APROBADA") == 0) {
            this.colorServicioPush = Constantes.COLOR_ESTADO_APROBADA;

          } else {
            if (element.nombreEstadoRequerimiento.localeCompare("ACEPTADA") == 0) {
              this.colorServicioPush = Constantes.COLOR_ESTADO_ACEPTADA;
            } else {
              if (element.nombreEstadoRequerimiento.localeCompare("RECHAZADA") == 0) {
                this.colorServicioPush = Constantes.COLOR_ESTADO_RECHAZADA;
              } else {
                if (element.nombreEstadoRequerimiento.localeCompare("CONFIRMADA") == 0) {
                  this.colorServicioPush = Constantes.COLOR_ESTADO_CONFIRMADA;
                } else {
                  if (element.nombreEstadoRequerimiento.localeCompare("NO CONFIRMADA") == 0) {
                    this.colorServicioPush = Constantes.COLOR_ESTADO_NOCONFIRMADA;
                  } else {
                    if (element.nombreEstadoRequerimiento.localeCompare("CANCELADA") == 0) {
                      this.colorServicioPush = Constantes.COLOR_ESTADO_CANCELADA;
                    } else {
                      if (element.nombreEstadoRequerimiento.localeCompare("NO APROBADA") == 0) {
                        this.colorServicioPush = Constantes.COLOR_ESTADO_NOAPROBADA;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      if (this.estadosServiciosParaMostrar.includes(element.nombreEstadoRequerimiento)) {
        this.actividadesEvents.push({
          "id": element.idRequerimientoCatering,
          "title": element.nombreEvento,
          "start": start,
          "end": end,
          "color": this.colorServicioPush,
          "detalle": element.nombreSubCategoria,
          "nombreEvento": element.nombreEvento,
          "direccionEvento": element.direccionEvento,
          "fechaEvento": element.fechaEvento,
          "horaInicio": element.horaInicioEvento,
          "horaFin": element.horaFinEvento,
          "nombreSubCategoria": element.nombreSubCategoria,
          "nombreEstadoRequerimiento": element.nombreEstadoRequerimiento,
          "valorTotalRequerimiento": element.valorTotalRequerimiento,
          "valorUnitarioSubCategoria": element.valorUnitarioSubCategoria,
          "cantidad": element.cantidad,
          "direccionReferenciaEvento": element.direccionReferenciaEvento,
          "idPersonaResponsableRecibirServicio": element.idPersonaResponsableRecibirServicio,
          "nombreResponsableRecibirServicio": element.nombreResponsableRecibirServicio,
          "telefonoResponsable": element.telefonoResponsable,
          "idEstadoRequerimiento": element.idEstadoRequerimiento,
          "idSubCategoria": element.idSubCategoria,
          "idUsuarioCreacion": element.idUsuarioCreacion,
          "usuarioCreacion": element.usuarioCreacion,
          "fechaCreacion": element.fechaCreacion,
          "idDisponibilidadPlanificacion": element.idDisponibilidadPlanificacion,
          "horaServicioEnEvento": element.horaServicioEnEvento,
          "personaCreoServicio": element.personaCreoServicio,
          "observaciones": element.observaciones,
          "tipoRequerimiento": element.tipoRequerimiento,
          "allday": true,
        });//hacer una lista de colores y q vaya pasando
      }

    });
  }

  async cambiaTipoVista() {
    this.fechaCalendario = new Date();
    this.fechaCalendario.setMonth(Number(this.numeroMesPlanificacion));
    this.fechaCalendario.setDate(1);
    console.log("fecha calendario " + this.fechaCalendario);
    this.estadosServiciosParaMostrar = [];
    if (this.isCheckedElaborada) {
      this.estadosServiciosParaMostrar.push("ELABORADA");
    }
    if (this.isCheckedPorAprobar) {
      this.estadosServiciosParaMostrar.push("POR APROBAR");
    }
    if (this.isCheckedAprobada) {
      this.estadosServiciosParaMostrar.push("APROBADA");
    }
    if (this.isCheckedNoAprobada) {
      this.estadosServiciosParaMostrar.push("NO APROBADA");
    }
    if (this.isCheckedAceptada) {
      this.estadosServiciosParaMostrar.push("ACEPTADA");
    }
    if (this.isCheckedRechazada) {
      this.estadosServiciosParaMostrar.push("RECHAZADA");
    }
    if (this.isCheckedConfirmada) {
      this.estadosServiciosParaMostrar.push("CONFIRMADA");
    }
    if (this.isCheckedNoConfirmada) {
      this.estadosServiciosParaMostrar.push("NO CONFIRMADA");
    }
    if (this.isCheckedCancelada) {
      this.estadosServiciosParaMostrar.push("CANCELADA");
    }
    this.cargarInformacionCalendario();

    if (this.selectedTipoVista.localeCompare("LISTADO") == 0) {
      this.router.navigate(['/planificacion/requerimiento-listar']);
      this.datosSesionService.tipoVistaActual = "LISTADO";
      this.datosSesionService.guardarTipoVistaActual("LISTADO");

    } else {
      if (this.selectedTipoVista.localeCompare("CALENDARIO") == 0) {
        this.options = {};
        this.options = {
          plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
          events: this.actividadesEvents,
          defaultDate: this.fechaCalendario,
          eventLimit: true,
          header: {
            left: '',
            center: 'title',
            right: ''
          },
          views: {
            agenda: {
              eventLimit: 3
            },
            month: {
              eventLimit: 4 // adjust to 4 events
            }
          },
          height: 700,
          allDayText: true,
          eventClick: (alEvent, jsEvent, view) => {
            this.titleDialogEvent = alEvent.title;

            this.nombreActividadCalendarioElectoral = alEvent.title;
            if (alEvent.end) {
              this.longDate = true;
              this.fechaFinDialog = new Date(alEvent.end);
            }
            else {
              this.longDate = false;
              this.fechaFinDialog = new Date(alEvent.start);
            }

            this.fechaInicioDialog = new Date(alEvent.start);
            this.muestra = true;
            this.titleDialogEvent = alEvent.title;

            this.requerimientoCateringSeleccionadoCalendario.idRequerimientoCatering = alEvent.id;
            //this.requerimientoCateringSeleccionadoCalendario.nombreEvento = alEvent.nombreEvento;
            if (alEvent.direccionEvento.length > 45) {
              this.requerimientoCateringSeleccionadoCalendario.direccionEvento = alEvent.direccionEvento;
              this.direccionTooltip = alEvent.direccionEvento;
              this.requerimientoCateringSeleccionadoCalendario.direccionEvento = this.requerimientoCateringSeleccionadoCalendario.direccionEvento.substring(0, 44) + " ....";
            } else {
              this.requerimientoCateringSeleccionadoCalendario.direccionEvento = alEvent.direccionEvento;
              this.direccionTooltip = "";
            }

            if (alEvent.nombreEvento.length > 45) {
              this.requerimientoCateringSeleccionadoCalendario.nombreEvento = alEvent.nombreEvento;
              this.nombreTooltip = alEvent.nombreEvento;
              this.requerimientoCateringSeleccionadoCalendario.nombreEvento = this.requerimientoCateringSeleccionadoCalendario.nombreEvento.substring(0, 44) + " ....";
            } else {
              this.requerimientoCateringSeleccionadoCalendario.nombreEvento = alEvent.nombreEvento;
              this.nombreTooltip = "";
            }

            if (alEvent.direccionReferenciaEvento != null) {
              if (alEvent.direccionReferenciaEvento.length > 45) {
                this.requerimientoCateringSeleccionadoCalendario.direccionReferenciaEvento = alEvent.direccionReferenciaEvento;
                this.direccionReferenciaEventoTooltip = alEvent.direccionReferenciaEvento;
                this.requerimientoCateringSeleccionadoCalendario.direccionReferenciaEvento = this.requerimientoCateringSeleccionadoCalendario.direccionReferenciaEvento.substring(0, 44) + " ....";
              } else {
                this.requerimientoCateringSeleccionadoCalendario.direccionReferenciaEvento = alEvent.direccionReferenciaEvento;
              }
              if (alEvent.direccionReferenciaEvento.length > 0) { this.hayDireccionReferencia = true; } else { this.hayDireccionReferencia = false; }
            } else {

              this.direccionReferenciaEventoTooltip = "";
              this.requerimientoCateringSeleccionadoCalendario.direccionReferenciaEvento = "";
              this.hayDireccionReferencia = false;
            }

            if (alEvent.observaciones != null) {
              if (alEvent.observaciones.length > 45) {
                this.requerimientoCateringSeleccionadoCalendario.observaciones = alEvent.observaciones;
                this.observacionesEventoTooltip = alEvent.observaciones;
                this.requerimientoCateringSeleccionadoCalendario.observaciones = this.requerimientoCateringSeleccionadoCalendario.observaciones.substring(0, 44) + " ....";
              } else {
                this.requerimientoCateringSeleccionadoCalendario.observaciones = alEvent.observaciones;
              }
              if (alEvent.observaciones.length > 0) { this.hayObservaciones = true; } else { this.hayObservaciones = false; }
            } else {

              this.observacionesEventoTooltip = "";
              this.requerimientoCateringSeleccionadoCalendario.observaciones = "";
              this.hayObservaciones = false;
            }

            this.requerimientoCateringSeleccionadoCalendario.tipoRequerimiento = alEvent.tipoRequerimiento;
            this.requerimientoCateringSeleccionadoCalendario.fechaEvento = alEvent.fechaEvento;
            this.requerimientoCateringSeleccionadoCalendario.horaInicioEvento = alEvent.horaInicio;
            this.requerimientoCateringSeleccionadoCalendario.horaFinEvento = alEvent.horaFin;
            this.requerimientoCateringSeleccionadoCalendario.nombreSubCategoria = alEvent.nombreSubCategoria;
            this.requerimientoCateringSeleccionadoCalendario.nombreEstadoRequerimiento = alEvent.nombreEstadoRequerimiento;
            this.requerimientoCateringSeleccionadoCalendario.valorTotalRequerimiento = alEvent.valorTotalRequerimiento;
            this.requerimientoCateringSeleccionadoCalendarioList = [];
            this.requerimientoCateringSeleccionadoCalendarioList.push(alEvent);
            this.requerimientoCateringSeleccionadoCalendario.colorEstadoRequerimiento = alEvent.color;
            this.requerimientoCateringSeleccionadoCalendario.idRequerimientoCatering = alEvent.id;

            if (alEvent.horaServicioEnEvento != null) {
              this.requerimientoCateringSeleccionadoCalendario.horaServicioEnEvento = alEvent.horaServicioEnEvento;
              this.hayHoraServicioEnEvento = true;
            } else {
              this.hayHoraServicioEnEvento = false;
            }

            if (alEvent.nombreEstadoRequerimiento.localeCompare("ELABORADA") == 0) {
              this.requerimientoCateringSeleccionadoCalendario.estadoElaborada = true;
            } else { this.requerimientoCateringSeleccionadoCalendario.estadoElaborada = false; }

            if (alEvent.nombreEstadoRequerimiento.localeCompare("ACEPTADA") == 0) {
              this.requerimientoCateringSeleccionadoCalendario.estadoAceptada = true;
            } else { this.requerimientoCateringSeleccionadoCalendario.estadoAceptada = false; }

            if (alEvent.telefonoResponsable != null) {
              this.requerimientoCateringSeleccionadoCalendario.telefonoResponsable = alEvent.telefonoResponsable;
              if (alEvent.telefonoResponsable.length > 0) { this.hayCelularPersonaRecibir = true; } else { this.hayCelularPersonaRecibir = false; }
            } else {
              this.requerimientoCateringSeleccionadoCalendario.telefonoResponsable = "";
              this.hayCelularPersonaRecibir = false;
            }

            if (alEvent.nombreResponsableRecibirServicio != null) {
              this.requerimientoCateringSeleccionadoCalendario.nombreResponsableRecibirServicio = alEvent.nombreResponsableRecibirServicio;
              if (alEvent.nombreResponsableRecibirServicio.length > 0) { this.hayNombrePersonaRecibir = true; } else { this.hayNombrePersonaRecibir = false; }
            } else {
              this.requerimientoCateringSeleccionadoCalendario.nombreResponsableRecibirServicio = "";
              this.hayNombrePersonaRecibir = false;
            }
            if (alEvent.idPersonaResponsableRecibirServicio != null) {
              this.requerimientoCateringSeleccionadoCalendario.idPersonaResponsableRecibirServicio = alEvent.idPersonaResponsableRecibirServicio;
            }


            this.requerimientoCateringSeleccionadoCalendario.personaCreoServicio = alEvent.personaCreoServicio;
            this.requerimientoCateringSeleccionadoCalendario.cantidad = alEvent.cantidad;
            this.requerimientoCateringSeleccionadoCalendario.idEstadoRequerimiento = alEvent.idEstadoRequerimiento;
            this.requerimientoCateringSeleccionadoCalendario.idSubCategoria = alEvent.idSubCategoria;
            this.requerimientoCateringSeleccionadoCalendario.usuarioCreacion = alEvent.usuarioCreacion;
            this.requerimientoCateringSeleccionadoCalendario.idUsuarioCreacion = alEvent.idUsuarioCreacion;
            this.requerimientoCateringSeleccionadoCalendario.fechaCreacion = alEvent.fechaCreacion;
            this.requerimientoCateringSeleccionadoCalendario.idDisponibilidadPlanificacion = alEvent.idDisponibilidadPlanificacion;

          },

          dateClick: (e) => {

          }
        };
        this.header = {
          left: '',
          center: 'title',
          right: ''
        };
        this.showListado = false;
      }
    }
  }
  getColorCalendario(i: number) {
    let color;
    if (Constantes.COLORS_CALENDARIO[i]) {
      color = Constantes.COLORS_CALENDARIO[i];
    } else {
      color = this.getRandomColor();
    }
    return color;
  }
  getRandomColor(): string {
    return '#' + Math.floor(Math.random() * 16777215).toString(16);
  }
  checkValueElaborada(event: any) {
    this.cambiaTipoVista();
    if (this.isCheckedElaborada) {
      this.mostrarMensajeInfo("Se muestran las servicios en estado elaborada");
    } else {
      this.mostrarMensajeInfo("Se ocultan las servicios en estado elaborada");
    }
  }
  checkValuePorAprobar(event: any) {
    this.cambiaTipoVista();
    if (this.isCheckedPorAprobar) {
      this.mostrarMensajeInfo("Se muestran las servicios en estado por aprobar");
    } else {
      this.mostrarMensajeInfo("Se ocultan las servicios en estado por aprobar");
    }
  }
  checkValueAprobada(event: any) {
    this.cambiaTipoVista();
    if (this.isCheckedAprobada) {
      this.mostrarMensajeInfo("Se muestran las servicios en estado aprobada");
    } else {
      this.mostrarMensajeInfo("Se ocultan las servicios en estado aprobada");
    }
  }
  checkValueNoAprobada(event: any) {
    this.cambiaTipoVista();
    if (this.isCheckedNoAprobada) {
      this.mostrarMensajeInfo("Se muestran las servicios en estado no aprobada");
    } else {
      this.mostrarMensajeInfo("Se ocultan las servicios en estado no aprobada");
    }
  }
  checkValueAceptada(event: any) {
    this.cambiaTipoVista();
    if (this.isCheckedAceptada) {
      this.mostrarMensajeInfo("Se muestran las servicios en estado aceptada");
    } else {
      this.mostrarMensajeInfo("Se ocultan las servicios en estado aceptada");
    }
  }
  checkValueRechazada(event: any) {
    this.cambiaTipoVista();
    if (this.isCheckedRechazada) {
      this.mostrarMensajeInfo("Se muestran las servicios en estado rechazada");
    } else {
      this.mostrarMensajeInfo("Se ocultan las servicios en estado rechazada");
    }
  }

  checkValueConfirmada(event: any) {
    this.cambiaTipoVista();
    if (this.isCheckedConfirmada) {
      this.mostrarMensajeInfo("Se muestran las servicios en estado confirmada");
    } else {
      this.mostrarMensajeInfo("Se ocultan las servicios en estado confirmada");
    }
  }
  checkValueNoConfirmada() {
    this.cambiaTipoVista();
    if (this.isCheckedNoConfirmada) {
      this.mostrarMensajeInfo("Se muestran las servicios en estado no confirmada");
    } else {
      this.mostrarMensajeInfo("Se ocultan las servicios en estado no confirmada");
    }
  }
  checkValueCancelada() {
    this.cambiaTipoVista();
    if (this.isCheckedCancelada) {
      this.mostrarMensajeInfo("Se muestran las servicios en estado cancelada");
    } else {
      this.mostrarMensajeInfo("Se ocultan las servicios en estado cancelada");
    }
  }
  cancelarDialogActividad() {
    this.muestra = false;
  }
  enviarAprobacionClickCalendario() {

    this.requerimientoCateringSeleccionado = this.requerimientoCateringSeleccionadoCalendario;
    this.muestra = false;

    this.verificaSiEsPlanificacion();
    /*let fechaActual = new Date();
    fechaActual.setHours(0);
    fechaActual.setMinutes(0);
    fechaActual.setSeconds(0);*/
    
    this.fechaAuxActual = new Date();
    this.fechaAuxActual.setHours(0);
    this.fechaAuxActual.setMinutes(0);
    this.fechaAuxActual.setSeconds(0);    
    this.fechaAuxActual.setMilliseconds(0);
      
    this.fechaAuxEvento = new Date(this.requerimientoCateringSeleccionado.fechaEvento+ "T00:00:00");
    
    //console.log(" -- "+ this.requerimientoCateringSeleccionado.fechaEvento + "fecha evento"+ fechaActual+ " ++");

    if (this.fechaAuxEvento.getTime() >= this.fechaAuxActual.getTime()) {
      if (this.requerimientoCateringSeleccionado.horaInicioEvento != this.requerimientoCateringSeleccionado.horaFinEvento) {
        if (this.ingresaComoPlanificacion) {
          console.log("Planificacion");
          this.confirmPosition("left");
        } else {
          if (this.requerimientoCateringSeleccionado.tipoRequerimiento == Constantes.TIPO_DISPONIBILIDAD_EXCEPCIONAL) {
            console.log("Excepcional");
            this.confirmPosition("left");
          } else {
            this.mostrarMensajeAdvertencia(this._mensajeValidaDisponibilidadEnviarAprobacion);
          }
        }
      } else {
        this.mostrarMensajeError("No se puede enviar para aprobación la hora de inicio y fin de evento son iguales");
      }
    } else {
      this.mostrarMensajeError("No se puede enviar para aprobación, La fecha del evento debe ser igual o mayor a la fecha actual");
    }
  }

  confirmPosition(position: string) {
    this.position = position;

    this.confirmationService.confirm({
      header: this._tituloEnviarRequerimientoCateringAprobacion,
      message: '¿Está seguro que desea enviar este registro para aprobación?',
      icon: 'pi pi-info-circle',
      acceptLabel: 'SI',
      accept: async () => {

        await this.cargaDatosRequerimientoGuardar(this.idEstadoPorRevisar, "S");
        this.busy = this.requerimientoCateringService.actualizar(this.requerimientoGuardar, this.requerimientoCateringSeleccionado.horaInicioEvento.toString(), this.requerimientoCateringSeleccionado.horaFinEvento.toString(), this.auxHoraServicioEnEvento).then(async req => {
          if (req) {

            this.busy = this.requerimientoCateringService.listarRequerimientoCateringByIdPlanificacion(this.datosSesionService.idPlanificacionActual).then(req => {
              if (req) {
                this.lstRequerimientoCateringDTO = req;
                for (var i = 0; i < this.lstRequerimientoCateringDTO.length; i++) {
                  this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento = this.lstRequerimientoCateringDTO[i].valorUnitarioSubCategoria * this.lstRequerimientoCateringDTO[i].cantidad;
                  this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento = Math.round(this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento * 10) / 10;
                }


                this.nombrePlanificacion = this.datosSesionService.nombrePlanificacionActual;

                this.cambiaTipoVista();

                this.muestra = false;


              }
            }).catch(error => {
              this.mostrarMensajeError("No se encuentra disponible el servicio de listar servicios, intente más adelante refrescando la pestaña o comuníquese con el administrador");
            });


          }
        }).catch(error => {
          this.mostrarMensajeError(error);

        });
      },
      reject: () => {

        this.muestra = true;
      },
      key: "positionDialog"
    });
  }
  cerrarDialogoReqCalendario() {
    this.muestra = false;
  }
  editarDialogoReqCalendario() {
    this.requerimientoCateringSeleccionado = this.requerimientoCateringSeleccionadoCalendario;
    this.muestra = false;
    this.editarClick();
  }
  copiarDialogoReqCalendario() {
    this.requerimientoCateringSeleccionado = this.requerimientoCateringSeleccionadoCalendario;
    this.muestra = false;
    this.confirmCopiarCalendario();

  }
  async confirmCopiarCalendario() {
    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idRequerimientoCatering) {
      await this.verificaSiEsPlanificacion();
      if (this.ingresaComoPlanificacion) {
        this.confirmationService.confirm({
          key: 'autorizacion',
          header: this._copiarServicioCatering,
          message: '¿Desea crear una copia en estado elaborada del registro seleccionado (Datos del evento y detalles del producto seleccionado)?',
          accept: () => {
            this.copiarRequerimientoCatering(0);
          }
        });
      } else {
        this.verificaSiEsExcepcional();
        if (this.ingresaComoExcepcional) {

          this.fechaHoraInicioExcep = new Date();
          this.fechaHoraFinExcep = new Date();

          this.fechaHoraInicioExcep = new Date(this.disponibilidadExcepcional.fechaInicio + "T" + this.disponibilidadExcepcional.horaInicio.substring(0, this.disponibilidadExcepcional.horaInicio.lastIndexOf(':')) + ":00");
          this.fechaHoraFinExcep = new Date(this.disponibilidadExcepcional.fechaFin + "T" + this.disponibilidadExcepcional.horaFin.substring(0, this.disponibilidadExcepcional.horaFin.lastIndexOf(':')) + ":00");
          let fechaActualCompare = new Date();
          fechaActualCompare.setSeconds(0);
          fechaActualCompare.setMilliseconds(0);

          if ((fechaActualCompare > this.fechaHoraInicioExcep && fechaActualCompare < this.fechaHoraFinExcep) || (fechaActualCompare.getTime() === this.fechaHoraInicioExcep.getTime()) || (fechaActualCompare.getTime() === this.fechaHoraFinExcep.getTime())) {
            this.confirmationService.confirm({
              key: 'autorizacion',
              header: this._copiarServicioCatering,
              message: 'Advertencia: Se creará una copia en estado elaborada con fecha y hora actual. Los datos del evento y detalles del producto seleccionado podrán ser modificados. ¿Desea continuar?',
              accept: () => {
                this.copiarRequerimientoCatering(1);//se envia 1 para indicar que no se va a copiar ni fechas ni horas
              }
            });
          } else {
            this.mostrarMensajeInfo("No se permite copiar requerimientos, no hay una disponibilidad activa, consulte al administrador del sistema");
          }


        } else {
          this.mostrarMensajeInfo("No se permite copiar requerimientos, no hay una disponibilidad activa, consulte al administrador del sistema");
        }
      }
    } else {
      this.mostrarMensajeInfo(this._noObjetoGrillaCopiar);

    }
  }
  eliminarDialogoReqCalendario() {
    this.requerimientoCateringSeleccionado = this.requerimientoCateringSeleccionadoCalendario;
    this.muestra = false;
    this.confirmEliminarCalendario();

  }

  confirmEliminarCalendario() {
    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idRequerimientoCatering) {
      if (this.requerimientoCateringSeleccionado.idEstadoRequerimiento == this.idEstadoElaborada) {
        this.confirmationService.confirm({
          key: 'eliminarDialog',
          header: this._eliminarServicioCatering,
          message: '¿Está seguro que desea eliminar el servicio seleccionado?',
          acceptLabel: 'SI',
          accept: () => {
            this.cargaDatosRequerimientoGuardar(this.requerimientoCateringSeleccionado.idEstadoRequerimiento, "N");

            this.requerimientoCateringService.actualizar(this.requerimientoGuardar, this.requerimientoCateringSeleccionado.horaInicioEvento.toString(), this.requerimientoCateringSeleccionado.horaFinEvento.toString(), this.auxHoraServicioEnEvento).then(req => {
              if (req) {
                this.busy = this.requerimientoCateringService.listarRequerimientoCateringByIdPlanificacion(this.datosSesionService.idPlanificacionActual).then(req => {
                  if (req) {
                    this.lstRequerimientoCateringDTO = req;
                    for (var i = 0; i < this.lstRequerimientoCateringDTO.length; i++) {
                      this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento = this.lstRequerimientoCateringDTO[i].valorUnitarioSubCategoria * this.lstRequerimientoCateringDTO[i].cantidad;
                      this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento = Math.round(this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento * 10) / 10;
                    }
                    this.nombrePlanificacion = this.datosSesionService.nombrePlanificacionActual;
                    this.cambiaTipoVista();
                    this.muestra = false;


                  }
                }).catch(error => {
                  this.mostrarMensajeError("No se encuentra disponible el servicio de listar servicios, intente más adelante refrescando la pestaña o comuníquese con el administrador");
                });

              }
            }).catch(error => {
              this.mostrarMensajeError(error);
            });
          },
          reject: () => {
            this.muestra = true;
          },
        });
      } else {
        this.mostrarMensajeError("Sólo se permite eliminar un servicio en estado elaborada");
      }
    } else {
      this.mostrarMensajeInfo(this._noObjetoGrillaEliminar);
    }
  }


  async guardarConfCancelClick() {



    if (this.selectedTipoEstado == Constantes.ESTADO_CONFIRMAR) {
      await this.cargaDatosRequerimientoGuardar(this.idEstadoConfirmar, Constantes.ESTA_ACTIVO_SI);
      if (this._validacionParaConfirmar()) {


        if (this._verificarTiempoConfirmar()) {
          if (this.idEstadoConfirmar > 0) {

            this.display = false;
            this._confirmarRequerimientoCateringConfirmar();


          }
        } else {
          this.mostrarMensajeInfo(this._mensajeValidacionTiempoConfirmarServicioCatering + " ( " + this.numeroHorasConfirmar + " horas antes del evento)");
        }


      }
    } else {

      await this.cargaDatosRequerimientoGuardar(this.idEstadoCancelar, Constantes.ESTA_ACTIVO_SI);

      if (this._verificarTiempoCancelar()) {
        if (this.idEstadoCancelar > 0) {
          this.display = false;

          this._confirmarRequerimientoCateringCancelar();
        }
      } else {
        this.mostrarMensajeInfo(this._mensajeValidacionTiempoCancelarServicioCatering);
      }
    }
  }

  _actualizarRequerimientoCatering() {
    this.busy = this.requerimientoCateringService.actualizar(this.requerimientoGuardar, this.requerimientoGuardar.horaInicioEvento.toString(), this.requerimientoGuardar.horaFinEvento.toString(), this.auxHoraServicioEnEvento).then(req => {
      if (req) {
        this.obtenerRequerimientoCatering();
        this.nombrePlanificacion = this.datosSesionService.nombrePlanificacionActual;
        this.requerimientoGuardar = null;
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }

  _validacionParaConfirmar(): boolean {
    let resultado = true;
    let mensajeError = this._tituloMensajeValidacionGrupal;
    if (this.requerimientoGuardar && this.requerimientoGuardar.direccionReferenciaEvento == null) {
      mensajeError += this._saltoLineaDetalle + this._mensajeValidacionConfirmarDireccionReferencia;
      resultado = false;
    }

    if (this.requerimientoGuardar && this.requerimientoGuardar.horaServicioEnEvento == null) {
      mensajeError += this._saltoLineaDetalle + this._mensajeValidacionConfirmarHoraServicio;
      resultado = false;
    }

    if (this.requerimientoGuardar && this.requerimientoGuardar.responsableRecibirServicio == null) {
      mensajeError += this._saltoLineaDetalle + this._mensajeValidacionConfirmarResponsable;
      resultado = false;
    }

    if (this.requerimientoGuardar && this.requerimientoGuardar.telefonoResponsable == null) {
      mensajeError += this._saltoLineaDetalle + this._mensajeValidacionConfirmarTelefono;
      resultado = false;
    }

    if (!resultado) {
      this.mostrarMensajeInfo(mensajeError);
      this.display = false;
    }

    return resultado;
  }

  async obtenerRequerimientoPorId(idReq) {
    this.requerimientoCateringService.buscarRequerimientoById(idReq).then(res => {
      if (res) {
        this.requerimientoCateringRecuperado = res;

      }

    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }

  /*_obtenerTiempoConfirmarServicioCatering() {
    this.configuracionGeneralCateringSerivice.buscarTipoConfiguracion(Constantes.TIPO_CONFIGURACION_CONFIRMAR).then(responseTipoConfig => {
      if (responseTipoConfig) {
        this.numeroHorasConfirmar = responseTipoConfig;
      }
    });
  }

  _obtenerTiempoCancelarServicioCatering() {
    this.configuracionGeneralCateringSerivice.buscarTipoConfiguracion(Constantes.TIPO_CONFIGURACION_CANCELAR).then(responseTipoConfig => {
      if (responseTipoConfig) {
        this.numeroHorasCancelar = responseTipoConfig;
      }
    });
  }*/

  _verificarTiempoConfirmar(): boolean {

    let resultado = true;

    if (this.requerimientoCateringSeleccionadoCalendario.tipoRequerimiento == Constantes.TIPO_DISPONIBILIDAD_NORMAL) {
      console.log("es normal")
      let formatoFecha = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      let fechaEventoA = this.requerimientoGuardar.fechaEvento
      let now = moment(formatoFecha, 'YYYY-MM-DD');
      let end = moment(fechaEventoA, 'YYYY-MM-DD');
      let horas = end.diff(now, 'hours');

      if (horas < this.numeroHorasConfirmar) {
        resultado = false;
      } else {
        console.log("Horas menor 2" + horas + " : " + this.numeroHorasConfirmar);
      }
    } else {
      console.log("es excepcional")
      let fechaEvento = new Date(this.requerimientoGuardar.fechaEvento + "T00:00:00")
      let fecha = new Date();
      fecha.setHours(0, 0, 0, 0);
      fechaEvento.setHours(0, 0, 0, 0);
      if (fecha > fechaEvento) {
        resultado = false;
      }
    }

    return resultado;
  }


  _verificarTiempoCancelar(): boolean {
    let resultado = true;

    if (this.requerimientoCateringSeleccionadoCalendario.tipoRequerimiento == Constantes.TIPO_DISPONIBILIDAD_NORMAL) {

      let formatoFecha = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      let fechaEventoA = this.requerimientoGuardar.fechaEvento
      let now = moment(formatoFecha, 'YYYY-MM-DD');
      let end = moment(fechaEventoA, 'YYYY-MM-DD');
      let horas = end.diff(now, 'hours');
      if (horas < this.numeroHorasCancelar) {
        resultado = false;
      }

    } else {
      let fechaEvento = new Date(this.requerimientoGuardar.fechaEvento + "T00:00:00")
      let fecha = new Date();
      fecha.setHours(0, 0, 0, 0);
      fechaEvento.setHours(0, 0, 0, 0);
      if (fecha > fechaEvento) {
        resultado = false;
      }
    }

    return resultado;
  }
  _confirmarRequerimientoCateringConfirmar() {
    this.confirmationService.confirm({
      key: 'autorizacion',
      header: this._tituloConfirmarRequerimientoCatering,
      message: this._mensajeConfirmarServicioCatering + this._saltoLinea + ' ¿Está seguro que desea confirmar el servicio seleccionado?',
      accept: () => {
        this._actualizarRequerimientoCatering();
      }
    });
  }

  _confirmarRequerimientoCateringCancelar() {
    this.confirmationService.confirm({
      key: 'autorizacion',
      header: this._tituloCancelarRequerimientoCatering,
      message: this._memsajeCancelarServicioCatering + this._saltoLinea + ' ¿Está seguro que desea cancelar el servicio seleccionado?',
      accept: () => {
        this._actualizarRequerimientoCatering();
      }
    });
  }
  async confirmarClickCalendario() {

    this.requerimientoCateringSeleccionado = this.requerimientoCateringSeleccionadoCalendario;
    await this.cargaDatosRequerimientoGuardar(this.idEstadoConfirmar, Constantes.ESTA_ACTIVO_SI);
    if (this._validacionParaConfirmar()) {
      this.configuracionGeneralCateringSerivice.buscarTipoConfiguracion(Constantes.TIPO_CONFIGURACION_CONFIRMAR).then(responseTipoConfig => {
        if (responseTipoConfig) {
          this.numeroHorasConfirmar = responseTipoConfig;//recupera el numero de horas para confirmar un servicio

          if (this._verificarTiempoConfirmar()) {
            if (this.idEstadoConfirmar > 0) {
              this.muestra = false;
              this.confirmarClickCalendarioConfirm();
            }
          } else {
            this.mostrarMensajeInfo(this._mensajeValidacionTiempoConfirmarServicioCatering + " ( " + this.numeroHorasConfirmar + " horas antes del evento)");
          }
        }
      });

    }

  }
  confirmarClickCalendarioConfirm() {
    this.confirmationService.confirm({
      key: 'confirmarCalendarioDialog',
      header: this._tituloConfirmarRequerimientoCatering,
      message: this._mensajeConfirmarServicioCatering + this._saltoLinea + ' ¿Está seguro que desea confirmar el servicio seleccionado?',
      accept: () => {
        this._actualizarRequerimientoCatering();
      }
      ,
      reject: () => {
        this.muestra = true;
      },
    });
  }
  async cancelarClickCalendario() {
    this.requerimientoCateringSeleccionado = this.requerimientoCateringSeleccionadoCalendario;
    await this.cargaDatosRequerimientoGuardar(this.idEstadoCancelar, Constantes.ESTA_ACTIVO_SI);
    this.configuracionGeneralCateringSerivice.buscarTipoConfiguracion(Constantes.TIPO_CONFIGURACION_CANCELAR).then(responseTipoConfig => {
      if (responseTipoConfig) {
        this.numeroHorasCancelar = responseTipoConfig;

        if (this._verificarTiempoCancelar()) {
          if (this.idEstadoCancelar > 0) {
            this.muestra = false;

            this._confirmarRequerimientoCateringCancelar();
          }
        } else {
          this.mostrarMensajeInfo(this._mensajeValidacionTiempoCancelarServicioCatering + " ( " + this.numeroHorasCancelar + " horas antes del evento)");
        }
      }
    });
  }

  /*cancelarClickCalendarioConfirm() {
    this.confirmationService.confirm({
      key: 'cancelarCalendarioDialog',
      header: this._tituloCancelarRequerimientoCatering,
      message: this._memsajeCancelarServicioCatering + this._saltoLinea + ' ¿Está seguro que desea cancelar el servicio seleccionado?',
      accept: () => {
        this._actualizarRequerimientoCatering();
      }
      ,
      reject: () => {
        this.muestra = true;
      },
    });
  }*/
  async copiarRequerimientoCatering(tipo) {
    this.cargaDatosRequerimientoGuardar(this.requerimientoCateringSeleccionado.idEstadoRequerimiento, "S");
    this.requerimientoGuardar.nombreEvento = "Copia de " + this.requerimientoCateringSeleccionado.nombreEvento;
    this.actualizarRequerimientoCateringCopiar(tipo);
  }

  actualizarRequerimientoCateringCopiar(tipo) {//crea la copia del registro    
    this.requerimientoGuardar.idRequerimientoCatering = null;
    this.requerimientoGuardar.nombreEvento = this.requerimientoGuardar.nombreEvento;
    this.requerimientoGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering = this.idEstadoElaborada;
    this.requerimientoGuardar.estaActivo = "S";
    this.requerimientoGuardar.editadoAceptado = false;
    this.requerimientoGuardar.direccionReferenciaEvento = null;
    this.requerimientoGuardar.horaServicioEnEvento = null;
    this.requerimientoGuardar.responsableRecibirServicio = null;
    this.requerimientoGuardar.telefonoResponsable = null;
    this.requerimientoGuardar.observaciones = null;
    if (tipo == 1) {//si es de tipo 1 quiere decir que es excepcional y no se copia ni con fecha ni con hora el requerimiento
      this.requerimientoGuardar.fechaEvento = new Date();

      this.requerimientoGuardar.horaInicioEvento = new Date();
      let horaInicio = this.datePipe.transform(this.requerimientoGuardar.horaInicioEvento, 'HH:mm:ss');
      this.requerimientoGuardar.horaFinEvento = this.requerimientoGuardar.horaInicioEvento;
      let horaFin = this.datePipe.transform(this.requerimientoGuardar.horaFinEvento, 'HH:mm:ss');
      console.log(horaInicio + " *** " + horaFin);

      if (this.requerimientoGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering != 0) {
        this.busy = this.requerimientoCateringService.actualizar(this.requerimientoGuardar, horaInicio, horaFin, "").then(req => {
          if (req) {
            this.obtenerRequerimientoCatering();
          }
        }).catch(error => {
          this.mostrarMensajeError(error);
        });
      } else {
        this.mostrarMensajeError("No se puede copiar el registro, no existe el tipo de requerimiento elaborada, comuníquese con el administrador");
      }

    } else {
      console.log(this.requerimientoGuardar.horaInicioEvento.toString() + " --- " + this.requerimientoGuardar.horaFinEvento.toString());
      var splittedInicio = this.requerimientoGuardar.horaInicioEvento.toString().split(":", 3);
      let horaInicio = new Date();
      horaInicio.setHours(parseInt(splittedInicio[0]));
      horaInicio.setMinutes(parseInt(splittedInicio[1]));
      horaInicio.setSeconds(parseInt(splittedInicio[2]));

      var splittedFin = this.requerimientoGuardar.horaFinEvento.toString().split(":", 3);
      let horaFin = new Date();
      horaFin.setHours(parseInt(splittedFin[0]));
      horaFin.setMinutes(parseInt(splittedFin[1]));
      horaFin.setSeconds(parseInt(splittedFin[2]));

      let horaI = this.datePipe.transform(horaInicio, 'HH:mm:ss');
      let horaF = this.datePipe.transform(horaFin, 'HH:mm:ss');



      if (this.requerimientoGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering != 0) {
        this.busy = this.requerimientoCateringService.actualizar(this.requerimientoGuardar, horaI, horaF, "").then(req => {
          if (req) {
            this.obtenerRequerimientoCatering();
          }
        }).catch(error => {
          this.mostrarMensajeError(error);
        });
      } else {
        this.mostrarMensajeError("No se puede copiar el registro, no existe el tipo de requerimiento elaborada, comuníquese con el administrador");
      }
    }
  }

}
